const config = require('../../../json/config.json');
const svgConfig = require('../../../json/svg.json');
import { doorSettingsStateStore } from '../../../assets/scripts/service/redux-service';
import { loadDoorSettingsState } from '../../../assets/scripts/service/localStorage-service';
const aaecState = require('../../../json/state/aaec-state.json');

export const rangeSlider = (() => {
    //Range input thumb position
    $('.range-slider input[type=range]').on('change input', function() {
        let max = $(this).attr('max') - $(this).attr('min');
        let value = $(this).val() - $(this).attr('min');
        let percent = value / max;
        let width = $(this).width() - 68;
		let left = percent * width + 40;

        $(this).prev('label').css('left', left);
        $(this).next('.range-slider__filler').css('width', left + 'px');
    });

    //Range input plus and minus button for incrementation of values
    $('.range-slider__more, .range-slider__less').on('click', function() {
        let $rangeSelector = $(this).parents(".range-slider__wrapper").find('input');
        let value = parseFloat($rangeSelector.val())
        let rangeMax = parseFloat($rangeSelector.attr('max'));
        let rangeMin = parseFloat($rangeSelector.attr('min'));
        let rangeStep = parseFloat($rangeSelector.attr('step'));
        let width = $(this).width();
        let currentUnit = getCurrentUnit();

        switch ($(this).hasClass('range-slider__more')) {
            case true:
                value = value === rangeMax ? value : value + rangeStep;
                const unitTypeMore = $( this ).parents('.range-slider').data('unit');
                $( ".door-" + unitTypeMore + "-value", '.customize-panel__grid').text( value + " " + currentUnit );
                break;
            case false:
                value = value === rangeMin ? value : value - rangeStep;
                const unitTypeLess = $( this ).parents('.range-slider').data('unit');
                $( ".door-" + unitTypeLess + "-value", '.customize-panel__grid').text( value + " " + currentUnit );
                break;
        }

        $rangeSelector.val(value).trigger('change');

    });

    //Prints out meters or feet underneath the range slider
    $('.range-slider').each(function() {
        let $selectorContainer = $(this).find('.range-slider__ticks');
        $(this).find('datalist option').each(function() {
            let value = $(this).html()
            $selectorContainer.append('<div>' + value + 'm</div>');
        });
    });
    
    function getCurrentUnit() {
        let unitLengthValue = "m";
		if (loadDoorSettingsState() !== undefined) {
			if ( loadDoorSettingsState().unit == "imperial" ) {
				unitLengthValue = "ft";
			} else if ( loadDoorSettingsState().unit == "metric" ) {
				unitLengthValue = "m";
			}
        }
        return unitLengthValue;
    }

})();


// WEBPACK FOOTER //
// ./src/components/inputs/range-slider/range-slider.js